import { Pipe, PipeTransform } from '@angular/core';

import { Helpers } from '../../core/classes/helpers';

@Pipe({
  name: 'toHtml',
  standalone: false
})
export class ToHtmlPipe implements PipeTransform {
  transform(value: string): string {
    return Helpers.replaceAll(value, '\n', '<br>');
  }
}
